import { Component, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className='flex flex-col items-center justify-center px-4 py-16 text-center'>
          <p className='mb-4 text-lg text-text'>ページの読み込みに失敗しました。</p>
          <button
            onClick={() => window.location.reload()}
            className='rounded-lg bg-primary px-6 py-2 text-white transition-opacity hover:opacity-90'
          >
            再読み込み
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
